<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-row v-if="errors">
                <v-col cols="12" sm="12" md="12">
                  <v-alert
                    dense
                    v-for="(v, k) in errors"
                    :key="k"
                    outlined
                    type="error"
                  >{{ k }} {{ v }}</v-alert>
                </v-col>
              </v-row>
              <v-card-title v-if="!tc_id">{{ 'Add Task' | translate }}</v-card-title>
              <v-card-title v-if="tc_id">{{ 'Edit Task' | translate }}</v-card-title>
              <v-card-text style="position: relative">
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="8" md="8">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-text-field
                            outlined
                            :label="'Task name' | translate"
                            name="tc_name"
                            v-model="tc_name"
                            autocomplete="off"
                            :rules="tcnameRules"
                            :disabled="(isUser? true : false)"
                            required
                          >
                          <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                              v-model="tc_templates"
                              :items="testcasetemplatedata"
                              item-value="temp_id"
                              item-text="temp_name"
                              :label="'Task template' | translate"
                              :rules="tctemplateRules"
                              :disabled="(isUser? true : false)"
                              outlined
                              chips
                              small-chips
                              multiple
                              required
                              :no-data-text="$t('No data available')"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>                              
                            </v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            outlined
                            name="tc_description"
                            v-model="tc_description"
                            :rules="tcdescriptionRules"
                            :disabled="(isUser? true : false)"
                            autocomplete="off"
                            :label="'Description' | translate"
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-textarea>
                        </v-col>
                      </v-row>

                      <v-row v-if="tc_id !== null ">
                        <v-col cols="12" sm="12">
                          <div class="pb-4 title">{{ 'Task templates' | translate}}</div>
                          <v-divider></v-divider>
                        </v-col>
                      </v-row>


                      <v-row v-if="tc_id !== null ">
                        <v-col cols="12" sm="12">
                        <v-data-table
                          :headers="headers"
                          :items="userTestCaseTemplates"
                          :single-expand="singleExpand"
                          :expanded.sync="expanded"
                          item-key="temp_id"
                          show-expand
                          class="elevation-1"
                          :footer-props="{ 'items-per-page-text': footertext, 'itemsPerPageOptions':[5,10,20,{ text: $t('All'), value: -1 }]   }"
                        >
                          <template slot="no-data">
                              {{ 'No data available' | translate }}
                          </template>
                          <template v-slot:footer.page-text="items"> 
                            {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }} 
                          </template>
                          <template v-slot:item.temp_view_file ="{ item }" >
                              <v-btn class="white--text" small :color="primary_color" v-on:click="downloadTestCaseTemplate(item.temp_files[0])">{{ 'View Template'| translate }}</v-btn>
                          </template>
                          <template v-slot:item.update ="{ item }" >
                              <v-btn class="white--text" small :color="primary_color" v-on:click="openDialog(item.temp_files[0].temp_id, item.temp_validity, item.temp_type, item.temp_files)" >{{ 'Update document'| translate }}</v-btn>
                          </template>
                            <template v-slot:item.data-table-expand="{ item ,expand, isExpanded }">
                              <v-icon v-if="!isExpanded" @click="expand(!isExpanded); showUserDocuments(item.temp_files[0].temp_id)">mdi-chevron-down</v-icon>
                              <v-icon v-if="isExpanded" @click="expand(!isExpanded)">mdi-chevron-up</v-icon>
                            </template>
                          <template v-slot:expanded-item="{ headers }">
                            <td :colspan="headers.length" style='padding: 0px !important;'>
                            <v-data-table
                              :headers="subdocumentheaders"
                              :items="userdocuments"
                              item-key="created_at"
                              class="elevation-1"
                              hide-default-footer
                              disable-pagination
                            >
                            <template slot="no-data">
                                {{ 'No data available' | translate }}
                            </template>
                            <template v-slot:footer.page-text="items">
                              {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }}
                            </template>
                            <template v-slot:item.view ="{ item }">
                                <v-btn class="white--text" small :color="primary_color" v-on:click="downloadUser(item.ud_id, item.updated_at, item.extension)">{{ 'View'| translate }}</v-btn>
                            </template>
                            <template v-slot:item.edit ="{ item }">
                                <v-btn class="white--text" small :color="primary_color" v-on:click="openeditDialog(item.ud_id,item.temp_id,item.due_date, item.status, item.hasOwnProperty('comment') ? item.comment: '')">{{ 'Edit'| translate }}</v-btn>
                            </template>
                            </v-data-table>
                            </td>
                          </template>
                        </v-data-table>
                        </v-col>
                      </v-row>



                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                    </v-col>
                  </v-row>
                </v-form>

                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  v-if="!tc_id && !isUser"
                  class="mx-2"
                  @click="submit"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>

                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  v-if="tc_id && !isUser"
                  class="mx-2"
                  @click="update"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      <v-dialog v-model="dialog" v-if="dialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline" v-if='editDocument'>{{ 'Edit task document' | translate }}</v-card-title>
          <v-card-title class="headline" v-else>{{ 'Update task document' | translate }}</v-card-title>
          <v-card-text>
              <v-card-text>
                <v-container>
                  <v-form id="modelform" ref="modelform">
                    <v-row>
                      <v-col v-if="documenterrors" cols="12" sm="12" md="12">
                        <v-alert
                          dense
                          v-for="(v, k) in documenterrors"
                          :key="k"
                          outlined
                          type="error"
                        >{{ k }} {{ v }}</v-alert>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-autocomplete
                            v-model="status"
                            :items="statusvalues"
                            item-value="value"
                            item-text="text"
                            :label="'Status' | translate"
                            :rules="statusRules"
                            outlined
                            chips
                            small-chips
                            required
                            :no-data-text="$t('No data available')"
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12">
                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="true"

                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              :label="'Due date' | translate"
                              v-model="due_date"
                              name="due_date"
                              :rules="dateRules"
                              autocomplete="off"
                              required
                              prepend-icon="mdi-calendar"
                              v-bind="attrs"
                              v-on="on"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="due_date"
                            no-title
                            scrollable
                            :locale="curLanguage.lang_code"
                            @input="menu=false"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>

                    <v-row v-if="formMessage != null">
                      <v-col cols="12" sm="12" md="12">
                        <v-alert
                          dense
                          outlined
                          type="error"
                        >{{ formMessage | translate }}</v-alert>
                      </v-col>
                    </v-row>

                    <v-tabs v-if='editDocument ==false '>
                      <v-tab @click="customForm()">{{ 'File form' | translate }}</v-tab>
                      <v-tab v-if="showCustomForm()" @click="fileForm()">{{ 'Custom form' | translate }}</v-tab>
                      <v-tab-item>
                        <v-form id="fileformData" ref="fileformData">
                        <v-row class="mt-4">
                            <v-col cols="12" sm="12">
                                <v-file-input
                                    id="document_file"
                                    name="filename"
                                    outlined
                                    chips
                                    required
                                    :label="'Select file' | translate"
                                    :rules="fileRules"
                                    @change="onFileSelectedTemplate"
                                >
                                <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>
                                </v-file-input>
                            </v-col>  
                            <v-col cols="12" sm="12">
                              <v-textarea
                                outlined
                                name="comment"
                                v-model="comment"
                                autocomplete="off"
                                :label="'Comment (optional)' | translate"
                              >
                              <template #message="{ message }">
                                {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                              </template>
                              </v-textarea>
                            </v-col>
                        </v-row>
                        </v-form>
                      </v-tab-item>
                      <v-tab-item v-if="showCustomForm()">
                        <v-form class="mt-4" id="customformData" ref="customformData">
                          <template v-for="(data,index) in metadatakeys">
                            <h3 :key="index" v-if="showCustomHeader(data)">{{ 'Page '+data }}</h3>
                            <v-row v-for="(metadata, indexvalue) of custommetadata[data]" :key="data+indexvalue+metadata.id">
                              <v-col cols="12" sm="12" md="12"  v-if ="metadata.fieldName == 'short_text' || metadata.fieldName == 'long_text' || metadata.fieldName == 'number'">
                                <v-text-field 
                                    v-if ="metadata.fieldName == 'short_text'"
                                    outlined
                                    type="text"
                                    :label="metadata.label"
                                    :id="data+indexvalue"
                                    autocomplete="off"
                                    required
                                    :rules="fieldRules"
                                    @keyup="saveMetaData(data,indexvalue,data+indexvalue)"
                                >
                                <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>                            
                                </v-text-field>
                                <v-text-field 
                                    v-else-if ="metadata.fieldName == 'number'"
                                    outlined
                                    type="number"
                                    :label="metadata.label"
                                    :id="data+indexvalue"
                                    autocomplete="off"
                                    required
                                    min="0"
                                    :rules="fieldRules"
                                    @keyup="saveMetaData(data,indexvalue,data+indexvalue)"
                                >
                                <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>                            
                                </v-text-field>
                                <v-textarea
                                  v-else-if ="metadata.fieldName == 'long_text'"
                                  outlined
                                  :id="data+indexvalue"
                                  autocomplete="off"
                                  required
                                  :label="metadata.label"
                                  :rules="fieldRules"
                                  @keyup="saveMetaData(data,indexvalue,data+indexvalue)"
                                >
                                <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>
                                </v-textarea>
                              </v-col>
                            </v-row>
                          </template>
                          <v-row>
                            <v-col cols="12" sm="12">
                              <v-textarea
                                outlined
                                name="comment"
                                v-model="comment"
                                autocomplete="off"
                                :label="'Comment (optional)' | translate"
                              >
                              <template #message="{ message }">
                                {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                              </template>
                              </v-textarea>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-tab-item>
                    </v-tabs>

                    <v-row v-if="editDocument">
                      <v-col cols="12" sm="12">
                        <v-textarea
                          outlined
                          name="comment"
                          v-model="comment"
                          autocomplete="off"
                          :label="'Comment (optional)' | translate"
                        >
                        <template #message="{ message }">
                          {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                        </template>
                        </v-textarea>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="closeBox">{{ 'Close' | translate }}</v-btn>
            <v-btn color="green darken-1" v-if="editDocument" text @click='editPersonalDocument()'>{{ 'Update' | translate }}</v-btn>
            <v-btn color="green darken-1" v-else text @click='uploadDocument'>{{ 'Upload' | translate }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </v-row>
    </v-container> 
  </v-content>
</template>  

<script>
import {
  FETCH_INDIVIDUAL_TEST_CASE,
  FETCH_TEST_CASE_TEMPLATE_DATA,
  ADD_TEST_CASE,
  UPDATE_TEST_CASE,
  FETCH_USER_DOCUMENTS,
  DOWNLOAD_USER_DOCUMENT,
  DOWNLOAD_TEST_CASE_TEMPLATE,
  UPDATE_USER_DOCUMENT,
  RESET_STATE
} from "@/store/actions.type";
import store from "@/store";
import { mapGetters } from "vuex"
import { mapState } from "vuex"
import { SET_SNACKBAR,SET_LOADING, SET_DOCUMENTS_ERROR } from "@/store/mutations.type"
export default {
  name: "addeditTestCase",
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(RESET_STATE);
    await store.dispatch(FETCH_TEST_CASE_TEMPLATE_DATA)
    if (to.params.id) {
      await store.dispatch(FETCH_INDIVIDUAL_TEST_CASE, to.params.id);
    }
    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE);
    next();
  },
  computed: {
    ...mapGetters(["individualtestcase",'userdocuments','curLanguage', "testcasetemplatedata",'currentUser']),
    ...mapState({
      errors: state => state.testcase.testcaseerrors,
      documenterrors: state => state.documents.documenterrors
    }),
    tcnameRules(){
     return [v => !!v || "Task name is required"]
    },
    userTestCaseTemplates(){
      return this.testcasetemplatedata.filter(o=> this.individualtestcase.tc_templates.includes(o.temp_id))
    },
    isUser(){
      if(this.currentUser.roles.includes(1)){
        return false;
      }
      return this.currentUser.roles.includes(4) 
    },     
    tctemplateRules(){ return [v => !!v || "Task template are required"]},
    tcdescriptionRules(){ return [v => !!v || "Task description is required"]},
    fieldRules() {return [v => !!v || "Field is required"]},
    fileRules() {return [
      v => !!v || 'File is required',
      v => (v && v.size > 0) || 'File is required',
    ]},
    statusRules(){
      return [v => !!v || "Status is required"]
    },
    dateRules(){
      return [v => !!v || "Date is required"]
    },
    headers () {
      return [
        { text: this.$t("Name"), value: "temp_name" },  
        { text: this.$t("Validity"), value: "temp_validity" },  
        { text: this.$t("View"), value: "temp_view_file" },
        {text: this.$t('Update'), value:'update'},
        { text: '', value: 'data-table-expand' },    
      ]
    },
    subdocumentheaders(){
      return [
            { text: this.$t("Status"), value: "status" },
            { text: this.$t("Due date"), value: "due_date" },
            { text: this.$t("Uploaded by"), value: "uploaded_user" },
            { text: this.$t("Uploaded on"), value: "created_at" },
            { text: this.$t('Edit'), value: 'edit' },
            { text: this.$t('View'), value: 'view' },
          ]
    },
    statusvalues(){
      return [
        { value: "active", text: this.$t("Active") },
        { value: "inactive", text: this.$t("Inactive") },
      ]
    },
    footertext(){
      return this.$t('Rows per page')
    },     
  },
  created(){
      if(!this.hasrequiredPermissions()){
        this.$router.push('/dashboard');
      }
      let company_meta  = JSON.parse(this.currentUser.company.company_meta)
      this.primary_color  = company_meta.primary_color 
      if(Object.keys(this.individualtestcase).length > 0){
      this.tc_name = this.individualtestcase.tc_name
      this.tc_id  =   this.individualtestcase.tc_id
      this.tc_description  =   this.individualtestcase.tc_description
      this.tc_templates = this.individualtestcase.tc_templates
      }   
  },
  data: () => ({
    tc_name: null,
    tc_id: null,
    tc_description:null,
    tc_templates: [],
    singleExpand: true,
    expanded: [],
    temp_type: null,
    dialog: false,
    editDocument: false,    
    doc_id: null,
    due_date: null,
    status: null,
    comment: null,
    personaldocumentid: null,
    file: null,
    menu: false,
    primary_color:null,
    custommetadata: {},
    filetemplate: null,
    metadatakeys:[],
    datacustom: {},
    formMessage: null,
  }),
  methods: {
    hasrequiredPermissions(){
      if(this.currentUser.roles.includes(1) == true || this.currentUser.permissions.includes('can-create-test-case') || this.currentUser.permissions.includes('can-update-test-case') ){
        return true;
      }
      return false;
    },
    fileForm() {
      this.formMessage = null
      document.getElementById('document_file').value=''
      this.comment=''
      this.$refs.fileformData.reset()
      if(this.$refs.customformData != undefined) {
        this.$refs.customformData.reset()
      }
    },
    customForm () {
      this.formMessage = null
      this.comment = ''
      document.getElementById('document_file').value=''
      this.$refs.fileformData.reset()
      this.$refs.customformData.reset()
    },
    saveMetaData(index,internalindexvalue, id) {
      const value = document.getElementById(id).value
      this.custommetadata[index][internalindexvalue].value = value
    },
    showCustomHeader(customkey) {
      let status = false
      this.custommetadata[customkey].forEach(metadata =>{
        if(metadata.fieldName == 'short_text' || metadata.fieldName == 'long_text' || metadata.fieldName == 'number'){
          status =true
        }
      })
      return status
    },
    showCustomForm () {
      let status = false
      for(let data in this.custommetadata) {
        this.custommetadata[data].forEach(metadata => {
          if(metadata.fieldName == 'short_text' || metadata.fieldName == 'long_text' || metadata.fieldName == 'number') {
            status = true
          }
        })
      }
      return status
    },
    onFileSelectedTemplate() {
      this.filetemplate = document.getElementById("document_file").files[0];
    },
    async downloadTestCaseTemplate(documentdata){
      await this.$store
        .dispatch(DOWNLOAD_TEST_CASE_TEMPLATE, 'view-file/'+documentdata.temp_id)
        .then(resp => {
            var byteCharacters = atob(resp.data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);

          var fileURL = window.URL.createObjectURL(new Blob([byteArray],{type: 'application/pdf'}));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', documentdata.updated_at+'.'+documentdata.extension);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$store.commit(SET_LOADING, false);

        });
    },
    async downloadUser(id, name , extension){
      await this.$store
        .dispatch(DOWNLOAD_USER_DOCUMENT, 'view-file/'+id)
        .then(resp => {
          var fileURL = window.URL.createObjectURL(new Blob([resp]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', name+'.'+extension);
          document.body.appendChild(fileLink);
          fileLink.click();
          store.commit(SET_LOADING, false);

        });
    },
    openDialog(id, days, type, files){
      this.metadatakeys = Object.keys(JSON.parse(files[0].temp_meta_data))
      this.custommetadata = JSON.parse(files[0].temp_meta_data)
      var currentDate = new Date()
      var validdate = new Date()
      validdate.setDate(currentDate.getDate()+days)
      this.dialog= true
      this.doc_id = id
      this.file=  null
      this.comment  = null
      this.due_date = validdate.toISOString().slice(0,10)
      this.status = null
      this.temp_type = type
    },
    openeditDialog(udid, idpersonaldocument,  duedate, status, comment){
      this.dialog= true
      this.doc_id = udid
      this.file=  null
      this.personaldocumentid = idpersonaldocument
      this.comment  = comment != undefined ? comment : ''
      this.due_date = duedate
      this.status = status
      this.editDocument = true
    },
    closeBox(){
      if(!this.editDocument) {
        document.getElementById('document_file').value=''
      }
      document.getElementById("modelform").reset();
      this.$store.commit(SET_DOCUMENTS_ERROR, [])
      this.dialog = false
      this.editDocument = false
      this.formMessage = null
    },
    async showUserDocuments(tempid){
      await this.$store.dispatch(FETCH_USER_DOCUMENTS,'?item_id='+this.individualtestcase.tc_id+'&temp_id='+tempid+'&inbox_filter=false').then(resp=>{
        if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
          this.$store.commit(SET_LOADING, false)
        }
        else{
          this.$store.commit(SET_LOADING, false)
        }
      })
    },
    onFileSelected() {
      this.file = document.getElementById("document_file").files[0];
    },
    async editPersonalDocument(){
      if (this.$refs.modelform.validate()) {
          var formData = new FormData(document.getElementById("modelform"));
          formData.set("item_id", this.individualtestcase.tc_id)
          formData.set("temp_id", this.personaldocumentid)
          formData.set('status', this.status)
          formData.set('due_date', this.due_date)
          formData.set('comment', this.comment)
          formData.set('ud_id', this.doc_id)
          formData.set('_method', 'put')
          this.$store.dispatch(UPDATE_USER_DOCUMENT, formData).then(async resp => {
            if (resp !==undefined && resp.success) {
                  await this.showUserDocuments(this.personaldocumentid)
                  store.commit(SET_SNACKBAR, {status: true, message: 'Task document updated successfully'})
                  this.dialog =false
                  this.doc_id = null
                  this.file=  ''
                  this.comment  = ''
                  this.due_date = ''
                  this.status = ''
                  this.editDocument = false
                  this.personaldocumentid = null
                  this.$refs.modelform.reset()
                  store.commit(SET_LOADING, false)
            }
            else if(resp !==undefined && !resp.success){
              store.commit(SET_LOADING, false)
            }
          });


      }
    },
    async uploadDocument(){
      if (this.$refs.modelform.validate()) {
          if(( this.$refs.customformData !=undefined  && this.$refs.customformData.validate()) || (this.$refs.fileformData !=undefined && this.$refs.fileformData.validate())) { 
            this.formMessage = null
          }
          else {
            this.formMessage = "Please fill custom form or file form completely"
            return ;             
          }

          var formData = new FormData(document.getElementById("modelform"));
          
          if(this.filetemplate != null && this.filetemplate != undefined && this.filetemplate != '') {
            formData.set("file", this.filetemplate)
          }
          else {
            formData.delete("file")
          }
          
          formData.set("item_id", this.individualtestcase.tc_id)
          formData.set("temp_id", this.doc_id)
          formData.set('status', this.status)
          formData.set('due_date', this.due_date)
          formData.set('comment', this.comment)

          if(this.filetemplate == null || this.filetemplate == undefined || this.filetemplate == '')
          formData.set('temp_meta_data',JSON.stringify(this.custommetadata))

          this.$store.dispatch(UPDATE_USER_DOCUMENT, formData).then(async resp => {
            if (resp !==undefined && resp.success) {
                  await this.showUserDocuments(this.doc_id)
                  store.commit(SET_SNACKBAR, {status: true, message: 'Task document updated successfully'})
                  this.$refs.modelform.reset()
                  this.dialog =false
                  this.doc_id = null
                  this.file=  null
                  this.comment  = null
                  this.due_date = null
                  this.status = null
                  this.editDocument = false
                  this.personaldocumentid = null
                  store.commit(SET_LOADING, false)

            }
            else if(resp !==undefined && !resp.success){
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    submit() {
        if (this.$refs.form.validate()) {
          let data = {
              tc_name: this.tc_name,
              tc_description: this.tc_description,
              tc_templates: this.tc_templates,
            }
            this.$store.dispatch(ADD_TEST_CASE, data).then(resp => {
            if (resp.success) {
               store.commit(SET_SNACKBAR, {status: true, message: 'Task added successfully'})
                this.$router.push({
                name: "testcase"
                });
            }
            });            
            
        }
    },
    update() {
        if (this.$refs.form.validate()) {
        let data = {
            tc_name: this.tc_name,
            tc_id: this.tc_id,
            tc_description: this.tc_description,
            tc_templates: this.tc_templates,
            _method: 'put'
          }
        this.$store.dispatch(UPDATE_TEST_CASE, data).then(resp => {
        if (resp.success) {
            store.commit(SET_SNACKBAR, {status: true, message: 'Task updated successfully'})
            this.$router.push({
            name: "testcase",
            });
        }
        });              
        }        
    }
  }
};
</script>